export const maxZoom = 14;
export const maxZoomSatellite = 8;
export const layerPadding = [50, 50, 50, 50];
export const mapReference = 'OSNI50k';
export const satelliteMapReference = 'Orthophotography';
